module.exports = location.host.toLowerCase() === 'dpgo.io'; // eslint-disable-line